import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-awesome-modal'
import { connect } from 'react-redux'
import { fetchParticipant } from 'Participant/ducks'
import ShowcaseOferta from './showcases/showcaseOferta'
import ShowcaseUnidade from './showcases/showcaseUnidade'
import Maps from './GoogleMaps'
import { ComunidadeIuppService as Service } from '../Services/ComunidadeIupp'
import { Link } from 'react-router-dom'

class HomeIupp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      location: false,
      visible: false,
      offers: null,
      offersEcomm: null,
      unitys: null,
      filterUnity: {
        pagination: {
          pageSize: 100,
          pageNumber: 1
        },
        filter: {
          chain: {
            ids: []
          },
          geoNear: {
            maxDistance: 500000,
            location: {
              latitude: -23.4945212,
              longitude: -46.7066441
            }
          }
        }
      },
      filterOffers: {
        pagination: {
          pageSize: 10,
          pageNumber: 1
        },
        filter: {
          chain: {
            ids: []
          },
          advertisementType: [0],
          geoNear: {
            maxDistance: 500000,
            location: {
              latitude: -23.4945212,
              longitude: -46.7066441
            }
          }
        }
      },
      filterOffersEcomm: {
        pagination: {
          pageSize: 10,
          pageNumber: 1
        },
        filter: {
          chain: {
            ids: []
          },
          advertisementType: [1],
          geoNear: {
            maxDistance: 500000,
            location: {
              latitude: -23.4945212,
              longitude: -46.7066441
            }
          }
        }
      }
    }
  }

  componentDidMount () {
    this.props.fetchParticipant()
    this.handleVerifyToken()
    this.handleGetOffers()
    this.handleGetUnity()
    this.handleGetEcomm()
    navigator.geolocation.getCurrentPosition(
      () => {
        this.handleOpenDialogGeoLocation()
      },
      () => {
        this.handleSetLocation()
      }
    )
  }

  openModal = () => {
    this.setState({ visible: true })
  }

  closeModal = () => {
    this.setState({ visible: false })
  }

  handleSetLocation = async () => {
    navigator.geolocation.getCurrentPosition(
      position => {
        this.setState({
          location: true,
          filterUnity: {
            pagination: {
              pageSize: 100,
              pageNumber: 1
            },
            filter: {
              chain: {
                ids: []
              },
              geoNear: {
                maxDistance: 500000,
                location: {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude
                }
              }
            }
          },
          filterOffers: {
            pagination: {
              pageSize: 10,
              pageNumber: 1
            },
            filter: {
              chain: {
                ids: []
              },
              advertisementType: [0],
              geoNear: {
                maxDistance: 500000,
                location: {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude
                }
              }
            }
          },
          filterOffersEcomm: {
            pagination: {
              pageSize: 10,
              pageNumber: 1
            },
            filter: {
              chain: {
                ids: []
              },
              advertisementType: [1],
              geoNear: {
                maxDistance: 500000,
                location: {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude
                }
              }
            }
          }
        })
        window.sessionStorage.setItem(
          'lat',
          position.coords.latitude.toString()
        )
        window.sessionStorage.setItem(
          'lng',
          position.coords.longitude.toString()
        )
        this.handleGetOffers()
        this.handleGetUnity()
        this.handleGetEcomm()
      },
      err => {
        window.localStorage.removeItem('lat')
        window.localStorage.removeItem('lng')
        switch (err.code) {
          case err.PERMISSION_DENIED:
            console.log('Usuário rejeitou a solicitação de Geolocalização')
            this.handleGetGeolocation(
              this.props.participant.address.zipCode.value
            )
            break
          case err.POSITION_UNAVAILABLE:
            console.log('Localização indisponível.')
            break
          case err.TIMEOUT:
            console.log('tempo da requisição expirou')
            break
          case err.UNKNOWN_ERROR:
            console.log('Algum erro desconhecido aconteceu')
            break
        }
      },
      {
        timeout: 3000
      }
    )
    this.closeModal()
  }

  handleGetGeolocation = async zipcode => {
    const resultLocation = await Service.getLocation(zipcode)
    const paginationUnity = {
      pageSize: 100,
      pageNumber: 1
    }
    const pagination = {
      pageSize: 10,
      pageNumber: 1
    }
    const geoNear = {
      maxDistance: 500000,
      location: {
        latitude:
          resultLocation && resultLocation.data.objectReturn.location.lat,
        longitude:
          resultLocation && resultLocation.data.objectReturn.location.lng
      }
    }
    const payloadUnity = {
      pagination: paginationUnity,
      filter: {
        chain: {
          categories: []
        },
        geoNear: geoNear
      }
    }
    const payloadOffers = {
      pagination: pagination,
      filter: {
        chain: {
          categories: []
        },
        advertisementType: [0],
        geoNear: geoNear
      }
    }
    const payloadOffersEcomm = {
      pagination: pagination,
      filter: {
        chain: {
          categories: []
        },
        advertisementType: [1],
        geoNear: geoNear
      }
    }

    window.sessionStorage.setItem(
      'lat',
      resultLocation.data.objectReturn.location.lat.toString()
    )
    window.sessionStorage.setItem(
      'lng',
      resultLocation.data.objectReturn.location.lng.toString()
    )
    // Verificar Amanha
    const resultOffers = await Service.getOffers(payloadOffers)
    const resultOffersEcomm = await Service.getOffers(payloadOffersEcomm)
    const resultUnitys = await Service.getUnitys(payloadUnity)
    this.setState({
      location: true,
      offersEcomm: resultOffersEcomm.data.objectReturn,
      unitys: resultUnitys.data.objectReturn,
      offers: resultOffers.data.objectReturn
    })
    this.setState({
      filterUnity: payloadUnity,
      filterOffers: payloadOffers,
      filterOffersEcomm: payloadOffersEcomm
    })
  }
  handleCleanLocation = () => {
    window.sessionStorage.removeItem('lat')
    window.sessionStorage.removeItem('lng')
    this.handleGetGeolocation(this.props.participant.address.zipCode.value)
    this.closeModal()
  }
  handleOpenDialogGeoLocation = () => {
    if (
      !window.sessionStorage.getItem('lat') &&
      !window.sessionStorage.getItem('lng')
    ) {
      this.setState({ visible: true })
    } else {
      this.handleSetLocation()
    }
  }

  handleVerifyToken = async () => {
    await Service.tokenVerify()
  }

  handleGetOffers = async () => {
    const resultOffers = await Service.getOffers(this.state.filterOffers)
    this.setState({ offers: resultOffers.data.objectReturn })
  }

  handleGetUnity = async () => {
    const resultUnitys = await Service.getUnitys(this.state.filterUnity)
    this.setState({ unitys: resultUnitys.data.objectReturn })
  }

  handleGetEcomm = async () => {
    const resultOffersEcomm = await Service.getOffers(
      this.state.filterOffersEcomm
    )
    this.setState({ offersEcomm: resultOffersEcomm.data.objectReturn })
  }

  handleRedirectToSignupComunidadeIupp = () => {
    window.location.href = `https://${process.env.REACT_APP_COMUNIDADE_IUPP_SIGNUP}`
  }

  render () {
    return (
      <Fragment>
        <Modal
          visible={this.state.visible}
          width='580'
          height='250'
          effect='fadeInUp'
        >
          <div className='ModalAlertLocal'>
            <div className='headerLocal'>
              <h1>queremos mostrar ofertas próximas de você.</h1>
            </div>
            <div className='bodyLocal'>
              <p>
                para isso precisamos que você divida sua localização com a
                gente.
              </p>
              <div className='btnLocations'>
                <div
                  className='BtnAgoraNao'
                  onClick={() => this.handleCleanLocation()}
                >
                  agora não
                </div>
                <div
                  className='BtnAtivarLocalizar'
                  onClick={() => this.handleSetLocation()}
                >
                  ativar localização
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <div className='container mt-2'>
          <div className='destaque-meu-bairro col-12 col-md-12 bordered radius border-color-ui-3'>
            <p className='pl-3'>
              o itaú incentiva o comércio local.
              <br /> cadastre seu negócio e venda também no iupp.
            </p>
            <div
              className='btn-vender-link'
              onClick={() => this.handleRedirectToSignupComunidadeIupp()}
            >
              quero vender
            </div>
          </div>
          {this.state.unitys !== null && this.state.unitys.numberOfRows > 0
            ? <div>
              <ShowcaseUnidade
                unitys={this.state.unitys}
                handleOpenDialogGeoLocation={this.handleOpenDialogGeoLocation}
                location={this.state.location}
                showcaseType='unidade'
              />
              <div
                className='d-flex color-brand-1 tit-ver-todas-b mt-2'
                onClick={() => {
                  window.location.href = '/comunidade-iupp/searchStores/'
                }}
                title='Vai para todas unidades'
              >
                <strong className='mr-1'>ver todas unidades</strong>
                <i className='icon icon-sm icon_right color-brand-1' />
              </div>
            </div>
            : ''}
          {this.state.offers !== null && this.state.offers.numberOfRows > 0
            ? <div>
              <ShowcaseOferta
                offers={this.state.offers}
                handleOpenDialogGeoLocation={this.handleOpenDialogGeoLocation}
                location={this.state.location}
                showcaseType='ofertafisica'
              />
              <div
                className='d-flex color-brand-1 tit-ver-todas-b mt-2'
                onClick={() => {
                  window.location.href = '/comunidade-iupp/search/'
                }}
                title='Vai para ofertas por categorias'
              >
                <strong className='mr-1'>ver todas ofertas de lojas</strong>
                <i className='icon icon-sm icon_right color-brand-1' />
              </div>
            </div>
            : ''}
          {this.state.offersEcomm !== null && this.state.offersEcomm.numberOfRows > 0
            ? <div>
              <ShowcaseOferta
                offers={this.state.offersEcomm}
                showcaseType='ecommerce'
              />
              <div
                className='d-flex color-brand-1 tit-ver-todas-b mt-2'
                onClick={() => {
                  window.location.href = '/comunidade-iupp/searchEcomm/'
                }}
                title='Vai para ofertas virtuais por categorias'
              >
                <strong className='mr-1'>ver todas ofertas virtuais</strong>
                <i className='icon icon-sm icon_right color-brand-1' />
              </div>
            </div>
            : ''}

          <div className='overflowHidden pb-1'>
            <p className='floatLeft mt-2 titleOfertas'>
              aproveite as ofertas por categorias.
            </p>
            <div
              className='floatRight d-flex color-brand-1 tit-ver-todas-b mt-2'
              onClick={() => {
                window.location.href = '/comunidade-iupp/search/'
              }}
              title='Vai para ofertas por categorias'
            >
              <strong className='mr-1'>ver todas</strong>
              <i className='icon icon-sm icon_right color-brand-1' />
            </div>
          </div>
          <div className='d-flex flex-direct-b'>
            <div className='card card-bairro mt-2'>
              <div className='cardCate cardCateFeatured radius d-flex-mob'>
                <div className='postionBairro'>
                  <p className='primer1Bairro'>
                    descontos
                    <br /> em farmácias.
                  </p>
                  <Link to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_FARMACIA}`} title={'Ver Ofertas de Farmácias'}>
                    <div className='divOfertas'>
                      <strong className='primer1Bairro'>
                      ver ofertas
                        <i className='icon icon-sm icon_right_app primer1Bairro' />
                      </strong>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className='card card-bairro mt-2'>
              <div className='cardCate cardBrand1 radius d-flex-mob'>
                <div className='postionBairro'>
                  <p className='primer2Bairro'>
                    descontos
                    <br /> em padarias.
                  </p>
                  <Link to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_PADARIA}`} title={'Ver Ofertas de Padarias'}>
                    <div className='divOfertas'>
                      <strong className='primer2Bairro'>
                      ver ofertas
                        <i className='icon icon-sm icon_right_app primer2Bairro' />
                      </strong>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className='card card-bairro mt-2'>
              <div className='cardCate cardUi4 radius d-flex-mob'>
                <div className='postionBairro'>
                  <p className='primer1Bairro'>
                    descontos
                    <br /> em supermercados
                  </p>
                  <Link to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_SUPERMERCADO}`} title={'Ver Ofertas de Supermercados'}>
                    <div className='divOfertas'>
                      <strong className='primer1Bairro'>
                      ver ofertas
                        <i className='icon icon-sm icon_right_app primer1Bairro' />
                      </strong>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className='card card-bairro mt-2'>
              <div className='cardCate cardBrand4 radius d-flex-mob'>
                <div className='postionBairro'>
                  <p className='primer2Bairro'>
                    descontos
                    <br /> em outras lojas
                  </p>
                  <div
                    className='divOfertas'
                    onClick={() => {
                      window.location.href = '/comunidade-iupp/search/'
                    }}
                  >
                    <strong className='primer2Bairro'>
                      ver ofertas
                      <i className='icon icon-sm icon_right_app primer2Bairro' />
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div
              className='btn-cards-mBairro mobile'
              onClick={() => {
                window.location.href = '/comunidade-iupp/search/'
              }}
            >
              Ver todas
            </div>
          </div>
          <div className='overflowHidden pb-1'>
            <p className='floatLeft mt-2 titleOfertas'>
              veja o que tem perto de você.
            </p>
            <div className='floatRight d-flex color-brand-1 tit-ver-todas-b mt-2'>
              <strong
                className='mr-1'
                onClick={() => {
                  window.location.href = '/comunidade-iupp/search/'
                }}
              >
                ver todas
              </strong>
              <i className='icon icon-sm icon_right color-brand-1' />
            </div>
          </div>
          <div className='mapa-space'>
            <div className='mapa-meu-bairro mt-2 mb-2'>
              <Maps
                stores={this.state.unitys}
                offers={this.state.offers}
                styles={{ width: '100%', height: '100%' }}
                google='https://maps.googleapis.com/maps/api'
                geolocation={{
                  lat: window.sessionStorage.getItem('lat'),
                  lng: window.sessionStorage.getItem('lng')
                }}
              />
            </div>
          </div>
          <div
            className='btn-cards-mBairro mobile'
            onClick={() => {
              window.open('https://www.iupp.com.br/', '_self')
            }}
          >
            Ver todas
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ participant }) => ({
  participant: participant
})

const mapDispatchToProps = dispatch => ({
  fetchParticipant: () => dispatch(fetchParticipant())
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeIupp)

HomeIupp.propTypes = {
  fetchParticipant: PropTypes.func,
  participant: PropTypes.object,
  zipCode: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/HomeIupp.js